import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ResumenVentasComponent } from './resumen-ventas/resumen-ventas.component';
import { EcommerceComponent } from './ecommerce/ecommerce.component';

const routes: Routes = [
  {
    path: '', children: [
      { path: 'tablero_de_control', component: DashboardComponent },
      { path: 'resumen_ventas', component: ResumenVentasComponent },
      { path: 'sales-ecommerce', component: EcommerceComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
